import Button from '@eversports/klimt-primitives/legacy/Button'
import SeoLink from '@eversports/klimt-primitives/legacy/SeoLink'
import Text from '@eversports/klimt-primitives/legacy/Text'

import { VenueOfferingType } from '../../../../App.types'
import getLinkToVenueFirstOffering from '../../../../helpers/get-link-to-venue-first-offering'
import { Localized } from '../../../../localization/react'

interface Props {
  offerings: Array<VenueOfferingType>
  slug: string
}

const CallToActionButton = ({ offerings, slug }: Props) => {
  const firstVenueOffering = offerings[0]
  const linkToVenueFirstOffering = getLinkToVenueFirstOffering({ firstVenueOffering, venueSlug: slug })

  if (!firstVenueOffering) {
    return (
      <Button variant="primary" sx={{ p: 3, width: '100%' }} disabled data-testid="venue-profile-book-now-action">
        <Text sx={{ textTransform: 'none', color: 'white', fontWeight: 'bold' }}>
          <Localized id="venue-profile-book-now" />
        </Text>
      </Button>
    )
  }

  return (
    <SeoLink
      encodedTo={btoa(linkToVenueFirstOffering)}
      external
      type="hidden"
      buttonVariant="primary"
      dataTestId="venue-profile-book-now-action"
    >
      <Text color="white" variant="large" sx={{ textTransform: 'none', fontWeight: 'bold' }}>
        <Localized id="venue-profile-book-now" />
      </Text>
    </SeoLink>
  )
}

export default CallToActionButton
